import React from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useLanguage } from '../../contexts/LanguageContext';
import styles from './VideoPlayerSection.module.scss';

interface VersionPlayerNavProps {
  total: number;
  currentIndex: number;
  canGoPrev: boolean;
  canGoNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  disabled?: boolean;
  showKeyboardHint?: boolean;
}

const VersionPlayerNav: React.FC<VersionPlayerNavProps> = ({
  total,
  currentIndex,
  canGoPrev,
  canGoNext,
  onPrev,
  onNext,
  disabled = false,
  showKeyboardHint = true,
}) => {
  const { t } = useLanguage();

  if (total <= 1) return null;

  return (
    <div className={styles.siblingTopNav}>
      <button
        type="button"
        className={styles.siblingTopNavButton}
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
        disabled={disabled || !canGoPrev}
        aria-label={t('fileDetail.siblingFileNavPrev')}
        title={showKeyboardHint ? t('fileDetail.siblingFileNavPrevHint') : t('fileDetail.siblingFileNavPrev')}
      >
        <LeftOutlined />
      </button>

      <span className={styles.siblingTopNavCounter}>
        {currentIndex >= 0 ? currentIndex + 1 : '-'}/{total}
      </span>

      <button
        type="button"
        className={styles.siblingTopNavButton}
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
        disabled={disabled || !canGoNext}
        aria-label={t('fileDetail.siblingFileNavNext')}
        title={showKeyboardHint ? t('fileDetail.siblingFileNavNextHint') : t('fileDetail.siblingFileNavNext')}
      >
        <RightOutlined />
      </button>
    </div>
  );
};

export default VersionPlayerNav;
